export default __webpack_public_path__ + "static/media/service--community-management.7e7f3ccc.webp";